import styled from 'styled-components';

export const Container = styled.section`
  background-size: auto 120%;
  background-position-y: ${({ top }) => top}%;
  transition: background-position-y 0.1s;

  img {
    max-width: unset;
  }
`;

export const Parent = styled.div`
  img {
    max-width: unset;
  }
`;

export const ParallaxFallthrough = styled.div`
  background: url('${({ src }) => src}');
  background-size: cover;
  background-position: center center;
`;



// WEBPACK FOOTER //
// ./src/components/animated-element/styles/animated-element.style.js